"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const ui_1 = require("@jbrowse/core/ui");
const mui_1 = require("tss-react/mui");
const mobx_react_1 = require("mobx-react");
// locals
const hooks_1 = require("../hooks");
const SequencePanel_1 = __importDefault(require("../SequencePanel"));
const SequenceFeatureMenu_1 = __importDefault(require("./SequenceFeatureMenu"));
const SequenceTypeSelector_1 = __importDefault(require("./SequenceTypeSelector"));
const useStyles = (0, mui_1.makeStyles)()({
    dialogContent: {
        width: '80em',
    },
    formControl: {
        margin: 0,
        marginLeft: 4,
    },
});
const SequenceDialog = (0, mobx_react_1.observer)(function ({ handleClose, model, feature, }) {
    const { sequenceFeatureDetails } = model;
    const { upDownBp } = sequenceFeatureDetails;
    const { classes } = useStyles();
    const seqPanelRef = (0, react_1.useRef)(null);
    const [force, setForce] = (0, react_1.useState)(false);
    const { sequence, error } = (0, hooks_1.useFeatureSequence)(model, feature, upDownBp, force);
    return (react_1.default.createElement(ui_1.Dialog, { maxWidth: "xl", open: true, onClose: () => handleClose(), title: "Sequence view" },
        react_1.default.createElement(material_1.DialogContent, { className: classes.dialogContent },
            react_1.default.createElement("div", null,
                react_1.default.createElement(SequenceTypeSelector_1.default, { model: sequenceFeatureDetails }),
                react_1.default.createElement(SequenceFeatureMenu_1.default, { ref: seqPanelRef, model: sequenceFeatureDetails })),
            react_1.default.createElement("div", null,
                feature.type === 'gene' ? (react_1.default.createElement(material_1.Typography, null, "Note: inspect subfeature sequences for protein/CDS computations")) : null,
                error ? (react_1.default.createElement(ui_1.ErrorMessage, { error: error })) : !sequence ? (react_1.default.createElement(ui_1.LoadingEllipses, null)) : sequence ? ('error' in sequence ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.Typography, { color: "error" }, sequence.error),
                    react_1.default.createElement(material_1.Button, { variant: "contained", color: "inherit", onClick: () => setForce(true) }, "Force load"))) : (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_1.LoadingEllipses, null) },
                    react_1.default.createElement(SequencePanel_1.default, { ref: seqPanelRef, feature: feature, sequence: sequence, model: sequenceFeatureDetails })))) : (react_1.default.createElement(material_1.Typography, null, "No sequence found")))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => handleClose(), variant: "contained" }, "Close"))));
});
exports.default = SequenceDialog;
